<template>
  <div v-bind:style="cssProps" id="app">
    <!-- <div class="extra-hint-text">
      Credit card payments are temporarily not possible. More information:
      <a href="https://solarfox.freshstatus.io/"
        >https://solarfox.freshstatus.io/</a
      >
    </div> -->
    <error-view />
    <div class="app-container">
      <router-view />
      <div class="link-container">
        <span>SOLEDOS GmbH - SOLARFOX® - HRB92443 - Gruendau, Germany</span>
        <span class="spacer"> | </span>
        <a
          target="_blank"
          class="imprint"
          href="https://www.solar-fox.com/en/imprint.html"
          >Imprint</a
        >
        <span class="spacer"> | </span>
        <a
          target="_blank"
          class="data-privacy"
          href="https://www.solar-fox.com/en/data-privacy.html"
          >Privacy policy</a
        >
      </div>
    </div>
    <div id="threeDS2-container" class="threeDS2-container" v-show="this.$store.state.threeDS2Payment"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import ErrorView from "@/components/Error.vue";

export default {
  name: "app",
  data() {
    return {
      cssProps: {
        backgroundImage: `url(${require("@/assets/background.png")})`,
      },
    };
  },
  components: {
    "error-view": ErrorView,
  },
  beforeMount() {
    //this.$router.push("/");
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  overflow: hidden;
}
#app {
  font-family: Arial;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888888;
}
.app-container {
  width: 75%;
  height: 90%;
  display: flex;
  box-shadow: 0px 0px 12px rgb(194, 193, 193);
  border-radius: 8px;
  background-color: white;
  padding: 20px 60px 20px 60px;
  position: relative;
}

.threeDS2-container {
  position: absolute;
  width: auto;
  height: auto;
  box-shadow: 0px 0px 12px rgb(194, 193, 193);
  border-radius: 8px;
  background-color: white;
  padding: 20px 60px 20px 60px;
  z-index: 99;
}

.input-container {
  width: 100%;
  height: 56px;
  display: flex;
  flex-direction: column;
}

.input-container-row {
  width: 100%;
  display: flex;
}

.input-container-row .input-container:first-child .input {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.input-container-row .input-container:nth-child(2) .input {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.input-container .headline {
  height: 22px;
  width: 100%;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.input {
  display: flex;
  height: 38px;
  align-items: center;
  width: 100%;
  padding-left: 10px;
  outline: none;
  font-size: 15px;
  border: 1px solid #e7e7e7;
  background-color: #e7e7e7;
  border-radius: 4px;
  color: grey;
}

.select {
  display: flex;
  height: 50px;
  align-items: center;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  outline: none;
  font-size: 15px;
  border: 1px solid #e7e7e7;
  background-color: #e7e7e7;
  border-radius: 4px;
  color: grey;
}
.textarea {
  display: flex;
  width: 100%;
  min-width: 400px;
  max-width: 400px;
  height: 430px;
  max-height: 430px;
  min-height: 430px;
  align-items: center;
  padding: 5px 0px 0px 10px;
  outline: none;
  font-size: 15px;
  border: 1px solid #e7e7e7;
  background-color: #e7e7e7;
  border-radius: 4px;
  color: grey;
}
.link-container {
  position: absolute;
  bottom: 5px;
  right: 8px;
  color: #4e4e4e;
  font-size: 13px;
  letter-spacing: 1.2px;
}
.imprint {
  color: #4e4e4e;
}
.data-privacy {
  color: #4e4e4e;
}
.spacer {
  margin: 0 5px;
  font-weight: bold;
}

@media screen and (max-width: 1420px) {
  .app-container {
    overflow: auto;
  }
}

.extra-hint-text {
  position: absolute;
  top: 20px;
  left: 12.5%;
  color: red;
  font-weight: bold;
}
</style>
